import { useT, Namespace } from "@racoon/i18n";
import { IcSettings } from "@racoon/icons";
import { useSettingsTabs } from "../model/useSettingsTabs";
import { SettingsTabs } from "../components/settings-tabs";
import { NotificationsSettings } from "../components/notifications-page/notifications-settings";
import { SettingsSection } from "../components/settings-section";
import { DepotSettings } from "../components/depots-page/depot-settings";
import { BunkerTypesSettings } from "../components/bunker-types-page";
import { TruckTypesSettings } from "../components/truck-types-page";
import { OrganizationLabelsSettings } from "../components/organization-labels";
import { AccessGroupsSettingsTab } from "../components/access-groups-page/access-groups.settings-tab";
import { TeamsSettings } from "../components/teams-page/teams-settings";
import { JobTypesSettings } from "../components/job-types-page/job-types-settings";
import { useAuthSession } from "~/shared/hooks/auth.session.admin";

export default function SettingsPage() {
  const t = useT();
  const { activeCompany: selectedCompany } = useAuthSession();

  const { activeTab, setActiveTab, tabs } = useSettingsTabs();

  return (
    <div className="flex h-full w-full flex-col gap-4">
      <header className="flex items-center gap-2 text-xl font-bold leading-6 tracking-[-0.01px]">
        <IcSettings className="size-8 shrink-0 text-blue-600" />
        <h1 className="text-text-body">{t(Namespace.Settings, "organizationSettings")}</h1>
        {selectedCompany?.name && <span className="text-blue-600">{selectedCompany.name}</span>}
      </header>

      <div className="flex min-h-0 flex-1 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm">
        <SettingsTabs activeTab={activeTab} tabs={tabs} onTabChange={setActiveTab} />

        <div
          id="settings-tab-panel"
          role="tabpanel"
          aria-labelledby={`settings-tab-${activeTab}-button`}
          className="flex min-w-0 flex-1 flex-col overflow-auto p-6"
        >
          {activeTab === "notifications" && (
            <NotificationsSettings companyId={selectedCompany?.id} />
          )}

          {activeTab === "depot" && <DepotSettings selectedCompanyId={selectedCompany?.id} />}

          {activeTab === "job_types" && <JobTypesSettings />}

          {activeTab === "pickup_location_types" && (
            <OrganizationLabelsSettings
              kind="pickupLocationTypes"
              selectedCompanyId={selectedCompany?.id}
            />
          )}

          {activeTab === "bunkerType" && (
            <BunkerTypesSettings selectedCompanyId={selectedCompany?.id} />
          )}

          {activeTab === "customer_types" && (
            <OrganizationLabelsSettings
              kind="customerTypes"
              selectedCompanyId={selectedCompany?.id}
            />
          )}

          {activeTab === "truck_types" && (
            <TruckTypesSettings selectedCompanyId={selectedCompany?.id} />
          )}

          {activeTab === "access_groups" && <AccessGroupsSettingsTab />}

          {activeTab === "teams" && <TeamsSettings selectedCompanyId={selectedCompany?.id} />}

          {activeTab === "general" && (
            <SettingsSection title={t(Namespace.Settings, "tabs.general")} comingSoon />
          )}
        </div>
      </div>
    </div>
  );
}
